<template>
  <v-dialog
    max-width="640"
    :fullscreen="smAndDown"
    v-model="dialogValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    persistent
    :z-index="1000000"
  >
    <div
      class="tw-relative tw-bg-white tw-py-12 tw-px-14 tw-rounded-2xl tw-h-full tw-overflow-y-auto tw-flex tw-flex-col tw-items-center tw-justify-center"
      :class="{
        'tw-px-4 tw-pt-6 tw-pb-6': smAndDown,
        'tw-rounded-none': smAndDown,
      }"
    >
      <!-- Ilustração -->
      <div class="tw-flex tw-justify-center tw-mb-10">
        <v-img
          src="@/assets/daai-coffee-check.svg"
          width="230"
          height="134"
          alt="Complete seu cadastro"
        />
      </div>

      <!-- Título -->
      <h2
        class="tw-text-xl tw-font-semibold tw-text-center tw-mb-3 tw-text-gray-600"
      >
        {{ $t('completedProfileModal.title') }}
      </h2>

      <!-- Descrição -->
      <div class="tw-text-sm tw-text-gray-600 tw-text-center tw-mb-10">
        <p>{{ $t('completedProfileModal.description') }}</p>
        <p>{{ $t('completedProfileModal.description2') }}</p>
      </div>

      <!-- Botão Principal -->
      <div class="tw-flex tw-justify-center tw-mb-4 tw-self-stretch">
        <v-btn
          color="primary"
          variant="flat"
          rounded
          size="large"
          class="tw-h-[52px] tw-px-8 tw-font-semibold tw-rounded-full"
          @click="handleBtnClick"
        >
          {{ $t('completedProfileModal.primaryButton') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import { useDisplay } from 'vuetify'

const { smAndDown } = useDisplay()

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const dialogValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const handleBtnClick = () => {
  window.location.reload()
}
</script>

<style scoped lang="scss">
:deep() {
  .v-btn--variant-text {
    text-transform: none;
  }
}
</style>
